module.exports = __webpack_public_path__ + "img/diamonds.85edb85.jpg";